import { render } from "./DocumentClassSearchMask.vue?vue&type=template&id=cd9e3cda&ts=true"
import script from "./DocumentClassSearchMask.vue?vue&type=script&lang=ts"
export * from "./DocumentClassSearchMask.vue?vue&type=script&lang=ts"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__